"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = exports.PopoverPosition = void 0;
const React = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Button_1 = require("../Button/Button");
var PopoverPosition;
(function (PopoverPosition) {
    PopoverPosition["BOTTOM"] = "bottom";
    PopoverPosition["BOTTOM_LEFT"] = "bottom-left";
    PopoverPosition["BOTTOM_RIGHT"] = "bottom-right";
    PopoverPosition["TOP"] = "top";
    PopoverPosition["TOP_LEFT"] = "top-left";
    PopoverPosition["TOP_RIGHT"] = "top-right";
    PopoverPosition["LEFT"] = "left";
    PopoverPosition["LEFT_TOP"] = "left-top";
    PopoverPosition["LEFT_BOTTOM"] = "left-bottom";
    PopoverPosition["RIGHT"] = "right";
    PopoverPosition["RIGHT_TOP"] = "right-top";
    PopoverPosition["RIGHT_BOTTOM"] = "right-bottom";
})(PopoverPosition || (exports.PopoverPosition = PopoverPosition = {}));
const PopoverContainer = Theme_1.styled.div `
  position: relative;
  display: inline-block;
  margin: 5px;
`;
const AnchorElementContainer = Theme_1.styled.div `
  display: inline-block;
`;
const PopoverContent = Theme_1.styled.div `
  border-radius: 4px;
  background: #fff;
  width: 160px;
  z-index: 1;
  padding: 15px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;
const CloseIconContainer = Theme_1.styled.div `
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px;
`;
const CloseButtonContainer = Theme_1.styled.div `
  display: flex;
  justify-content: flex-end;
`;
const Popover = (props) => {
    var _a, _b, _c, _d;
    const popoverRef = React.useRef(null);
    const anchorElementRef = React.useRef(null);
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const currentAnchorElement = anchorElementRef === null || anchorElementRef === void 0 ? void 0 : anchorElementRef.current;
    const anchorElementHeight = (_a = currentAnchorElement === null || currentAnchorElement === void 0 ? void 0 : currentAnchorElement.clientHeight) !== null && _a !== void 0 ? _a : 0;
    const anchorElementWidth = (_b = currentAnchorElement === null || currentAnchorElement === void 0 ? void 0 : currentAnchorElement.clientWidth) !== null && _b !== void 0 ? _b : 0;
    const currentPopover = popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current;
    const popoverHeight = (_c = currentPopover === null || currentPopover === void 0 ? void 0 : currentPopover.clientHeight) !== null && _c !== void 0 ? _c : 0;
    const popoverWidth = (_d = currentPopover === null || currentPopover === void 0 ? void 0 : currentPopover.clientWidth) !== null && _d !== void 0 ? _d : 0;
    const handleOutsideClick = (e) => {
        if (!(currentPopover === null || currentPopover === void 0 ? void 0 : currentPopover.contains(e.target)) &&
            !(currentAnchorElement === null || currentAnchorElement === void 0 ? void 0 : currentAnchorElement.contains(e.target))) {
            setIsPopoverOpen(false);
        }
    };
    React.useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    });
    const containerPosition = React.useMemo(() => {
        const marginAmount = props.separation || 5;
        const centerHorizontally = () => (popoverWidth / 2 - anchorElementWidth / 2) * -1;
        const centerVertically = () => (popoverHeight / 2 - anchorElementHeight / 2) * -1;
        switch (props.position) {
            case PopoverPosition.LEFT_BOTTOM:
                return {
                    top: 0,
                    right: anchorElementWidth + marginAmount,
                };
            case PopoverPosition.LEFT_TOP:
                return {
                    bottom: 0,
                    right: anchorElementWidth + marginAmount,
                };
            case PopoverPosition.LEFT:
                return {
                    top: centerVertically(),
                    right: anchorElementWidth + marginAmount,
                };
            case PopoverPosition.RIGHT_BOTTOM:
                return {
                    top: 0,
                    left: anchorElementWidth + marginAmount,
                };
            case PopoverPosition.RIGHT_TOP:
                return {
                    bottom: 0,
                    left: anchorElementWidth + marginAmount,
                };
            case PopoverPosition.RIGHT:
                return {
                    top: centerVertically(),
                    left: anchorElementWidth + marginAmount,
                };
            case PopoverPosition.TOP_LEFT:
                return {
                    bottom: anchorElementHeight + marginAmount,
                    right: 0,
                };
            case PopoverPosition.TOP_RIGHT:
                return {
                    bottom: anchorElementHeight + marginAmount,
                    left: 0,
                };
            case PopoverPosition.TOP:
                return {
                    bottom: anchorElementHeight + marginAmount,
                    right: centerHorizontally(),
                };
            case PopoverPosition.BOTTOM_RIGHT:
                return {
                    top: anchorElementHeight + marginAmount,
                    left: 0,
                };
            case PopoverPosition.BOTTOM:
                return {
                    top: anchorElementHeight + marginAmount,
                    right: centerHorizontally(),
                };
            case PopoverPosition.BOTTOM_LEFT:
            default:
                return {
                    top: anchorElementHeight + marginAmount,
                    right: 0,
                };
        }
    }, [
        anchorElementWidth,
        anchorElementHeight,
        popoverHeight,
        popoverWidth,
        props.position,
    ]);
    return (React.createElement(PopoverContainer, null,
        React.createElement(AnchorElementContainer, { onClick: () => setIsPopoverOpen(!isPopoverOpen), ref: anchorElementRef }, props.anchorElement),
        React.createElement(PopoverContent, { ref: popoverRef, style: Object.assign({ position: 'absolute', visibility: isPopoverOpen ? 'visible' : 'hidden', width: props.width }, containerPosition) },
            props.closeAction === 'icon' && (React.createElement(CloseIconContainer, null,
                React.createElement(Icon_1.default, { "data-testid": "icon-close", onClick: () => setIsPopoverOpen(false), icon: "close", size: "16" }))),
            props.children,
            props.closeAction === 'button' && (React.createElement(CloseButtonContainer, null,
                React.createElement(Button_1.Button, { "data-testid": "button-close", color: "blue", onClick: () => setIsPopoverOpen(false) }, "Close"))))));
};
exports.Popover = Popover;
//# sourceMappingURL=Popover.js.map